<template>
  <ap-config-provider :theme="{ token: tokenValue }">
    <div class="main-app-container">
      <RouterView />
      <GlobalLoader />
      <ContainerUpgradePlanModal />
      <LimitReachedModalsContainer />
    </div>
  </ap-config-provider>
</template>

<script setup>
import { onBeforeMount } from "vue"
import { useDark, useToggle } from "@vueuse/core"
import { RouterView } from "vue-router"
import { ApConfigProvider, useTheme } from "@Mobile-Leaves-CORP/ap-components"
import { useScreenHeight } from "./composables/screenHeight"
import ContainerUpgradePlanModal from "@/components/UpgradePlan/ContainerUpgradePlanModal.vue"
import LimitReachedModalsContainer from "@/components/LimitReachedModals/LimitReachedModalsContainer.vue"
import GlobalLoader from "@/components/GlobalLoader.vue"

const toggleDark = useToggle(useDark())
const { tokenValue, updateTheme } = useTheme()

onBeforeMount(() => {
  toggleDark(false)
  useScreenHeight()
}),
  updateTheme({
    fontFamily: "'Inter', sans-serif",
    colorPrimary: "#615DF4",
    colorError: "#cf1322",
    colorTextBase: "#121212",
    Table: {
      colorFillAlter: "transparent",
      colorFillContent: "transparent",
      colorFillSecondary: "transparent",
      lineWidth: 0
    },
    Select: {
      colorBgContainer: "#FAFAFA"
    },
    Input: {
      colorBgContainer: "#FAFAFA",
      colorTextPlaceholder: "#434343"
    },
    borderRadius: 4
  })
</script>

<style lang="postcss" scoped>
.main-app-container {
  @apply h-full w-full max-w-full;
  //overflow: hidden;
}
</style>
